import { memo, useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { Element } from 'src/components';
import { pageSelector } from 'src/selectors/app';
import { isNoAdSeclector } from 'src/selectors/ad';
import { useBoolean, usePrevious } from 'react-use';
import { AdUtils } from 'src/utils';
import { convertClassNames } from 'src/utils/style';
import styles from './styles.module.scss';
import { isOpenSelector } from 'src/selectors/content';
interface IProps {
    elId: string;
    className?: string;
    classNameContainer?: string;
    zoneAdaptive?: string;
    renderEl?: boolean;
    index?: number;
}

const AdBanner = ({
    elId,
    zoneAdaptive,
    className,
    classNameContainer = 'xxxxxx',
    renderEl = true,
}: IProps) => {
    const isNoAd = useSelector(isNoAdSeclector);
    const firstRender = useRef(true);
    const page = useSelector(pageSelector);
    const [adLoadSuccess, setAdLoadSuccess] = useBoolean(true);
    const isOpen = useSelector(isOpenSelector);
    const _onLoad = (isSuccess: boolean) => {
        firstRender.current = false;
        setAdLoadSuccess(Boolean(isSuccess));
    };
    const prevType = usePrevious(page.type);

    const elementId = isOpen ? `${elId}_Detail` : elId;

    useEffect(() => {
        if (!isNoAd && page.type) {
            if (isOpen) {
                setTimeout(() => {
                    AdUtils.loadAd(elementId, 'contentdetail', _onLoad);
                }, 200);
            } else {
                AdUtils.loadAd(elementId, page.type, _onLoad);
            }
        }
    }, [page, isNoAd]);

    useEffect(() => {
        if (
            typeof prevType !== 'undefined' &&
            prevType !== '' &&
            prevType !== page.type
        ) {
            firstRender.current = true;
        }
    }, [page]);

    const renderAdContent = useCallback(() => {
        return (
            <Element
                className={convertClassNames(styles, className)}
                id={elementId}
                data-adaptive={zoneAdaptive}
            />
        );
    }, [zoneAdaptive]);

    const showClass = adLoadSuccess ? 'is-show' : 'is-hide';

    if (isNoAd && firstRender.current) {
        return null;
    }

    return (
        <Element
            className={cn(
                styles[classNameContainer],
                styles[showClass],
                'ad-banner-list'
            )}
        >
            {renderEl && renderAdContent()}
        </Element>
    );
};

export default memo(AdBanner);
